import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionToGetCurriculumFileDataByIdApiCall } from "../../redux/action";
import { useParams } from "react-router-dom";
import CurriculumFlipbookContent from "./CurriculumFlipbookContent";
import CurriculumOtherContent from "./CurriculumOtherContent";
import Loader from "../Loader/Loader";
import CurriculumIndex from "./CurriculumIndex";

const CurriculumContent = () => {
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(true);
    const [activeTab, setActiveTab] = useState(0);
    const { slug, product_slug } = useParams();

    const curriculumFileListData = useSelector((state) => state.webSetting.curriculumFileListData);

    useEffect(() => {
        setIsLoading(true);
        if (slug) {
            dispatch(actionToGetCurriculumFileDataByIdApiCall({ slug })).then(() => setIsLoading(false));
        } else if (product_slug) {
            dispatch(actionToGetCurriculumFileDataByIdApiCall({  product_slug })).then(() => setIsLoading(false));
        }
    }, [dispatch,slug, product_slug]);

    const { curriculumFlipbookContent, curriculumOtherContent } = useMemo(() => {
        const flipbook = {};
        const otherContent = [];

        curriculumFileListData.forEach((res) => {
            if (res.type === 'flipbook') {
                flipbook[res.flipbook_code] = flipbook[res.flipbook_code] || [];
                flipbook[res.flipbook_code].push(res);
            } else {
                otherContent.push(res);
            }
        });

        return {
            curriculumFlipbookContent: flipbook,
            curriculumOtherContent: otherContent,
        };
    }, [curriculumFileListData]);

    if (isLoading) {
        return <Loader />;
    }


    return (
        <div className="flex flex-1 flex-col md:flex-row">
            {/* Left Side Index Panel */}
            <div className="lg:w-1/4 lg:h-full sm:w-full overflow-y-auto p-4">
                <CurriculumIndex activeTab={activeTab} setActiveTab={setActiveTab}/>
            </div>
            {/* Right Side Content Panel */}
            <div className="w-full h-full lg:w-1/2 lg:h-full  xl:w-full overflow-y-auto bg-gray-100 p-4 mt-20 md:ml-20 ">
                {activeTab < Object.values(curriculumFlipbookContent).length ? (
                    <CurriculumFlipbookContent contentData={Object.values(curriculumFlipbookContent)[activeTab]} />
                ) : (
                    <CurriculumOtherContent content={curriculumOtherContent[activeTab - Object.values(curriculumFlipbookContent).length]} />
                )}
            </div>
        </div>
    );
};

export default CurriculumContent;
